import { render, staticRenderFns } from "./QuantityButtonBasic.vue?vue&type=template&id=45871c2a&scoped=true"
import script from "./QuantityButtonBasic.vue?vue&type=script&lang=js"
export * from "./QuantityButtonBasic.vue?vue&type=script&lang=js"
import style0 from "./QuantityButtonBasic.vue?vue&type=style&index=0&id=45871c2a&scoped=true&lang=css"
import style1 from "./QuantityButtonBasic.vue?vue&type=style&index=1&id=45871c2a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45871c2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45871c2a')) {
      api.createRecord('45871c2a', component.options)
    } else {
      api.reload('45871c2a', component.options)
    }
    module.hot.accept("./QuantityButtonBasic.vue?vue&type=template&id=45871c2a&scoped=true", function () {
      api.rerender('45871c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/QuantityButtonBasic.vue"
export default component.exports